export default __webpack_public_path__ + "static/media/img-0454-montenegro-full-face.d1f8e2d4.png";